import type { NavioBuildOfflineCapability } from './naviobuild-offline-contract.js';

export const NAVIOBUILD_OFFLINE_CAPABILITIES = [
  {
    routeId: 'overview',
    path: '/',
    entities: ['project'],
    readScope: 'project_summary',
    queuedWriteRisk: 'low',
    conflictPolicy: 'field_level_merge',
    supportsSelectiveFileCache: false,
    requiredForLaunch: true,
  },
  {
    routeId: 'tracker',
    path: '/tracker',
    entities: ['tracker_item', 'file_asset'],
    readScope: 'project_working_set',
    queuedWriteRisk: 'medium',
    conflictPolicy: 'field_level_merge',
    supportsSelectiveFileCache: true,
    requiredForLaunch: true,
  },
  {
    routeId: 'setup',
    path: '/setup',
    entities: ['project', 'list_setting'],
    readScope: 'project_summary',
    queuedWriteRisk: 'medium',
    conflictPolicy: 'field_level_merge',
    supportsSelectiveFileCache: false,
    requiredForLaunch: true,
  },
  {
    routeId: 'lists',
    path: '/settings/lists',
    entities: ['list_setting'],
    readScope: 'project_working_set',
    queuedWriteRisk: 'medium',
    conflictPolicy: 'field_level_merge',
    supportsSelectiveFileCache: false,
    requiredForLaunch: true,
  },
  {
    routeId: 'schedule',
    path: '/schedule',
    entities: ['schedule', 'gantt', 'milestone'],
    readScope: 'project_working_set',
    queuedWriteRisk: 'medium',
    conflictPolicy: 'field_level_merge',
    supportsSelectiveFileCache: false,
    requiredForLaunch: true,
  },
  {
    routeId: 'spine',
    path: '/spine',
    entities: ['spine', 'certificate', 'test_record'],
    readScope: 'project_working_set',
    queuedWriteRisk: 'medium',
    conflictPolicy: 'field_level_merge',
    supportsSelectiveFileCache: false,
    requiredForLaunch: true,
  },
  {
    routeId: 'drawings',
    path: '/drawings',
    entities: ['drawing', 'file_asset'],
    readScope: 'selective_file_cache',
    queuedWriteRisk: 'high',
    conflictPolicy: 'human_review_required',
    supportsSelectiveFileCache: true,
    requiredForLaunch: true,
  },
  {
    routeId: 'tests',
    path: '/tests',
    entities: ['test_record', 'spine', 'file_asset'],
    readScope: 'project_working_set',
    queuedWriteRisk: 'medium',
    conflictPolicy: 'field_level_merge',
    supportsSelectiveFileCache: true,
    requiredForLaunch: true,
  },
  {
    routeId: 'ddr',
    path: '/ddr',
    entities: ['daily_report', 'ddr_template', 'regulatory_deliverable'],
    readScope: 'project_working_set',
    queuedWriteRisk: 'medium',
    conflictPolicy: 'append_only',
    supportsSelectiveFileCache: true,
    requiredForLaunch: true,
  },
  {
    routeId: 'regulatory',
    path: '/regulatory',
    entities: ['regulatory_deliverable'],
    readScope: 'project_working_set',
    queuedWriteRisk: 'high',
    conflictPolicy: 'human_review_required',
    supportsSelectiveFileCache: true,
    requiredForLaunch: true,
  },
  {
    routeId: 'payments',
    path: '/payments',
    entities: ['payment'],
    readScope: 'project_working_set',
    queuedWriteRisk: 'high',
    conflictPolicy: 'server_authoritative',
    supportsSelectiveFileCache: true,
    requiredForLaunch: true,
  },
  {
    routeId: 'variations',
    path: '/variations',
    entities: ['variation'],
    readScope: 'project_working_set',
    queuedWriteRisk: 'high',
    conflictPolicy: 'human_review_required',
    supportsSelectiveFileCache: true,
    requiredForLaunch: true,
  },
  {
    routeId: 'budget',
    path: '/budget',
    entities: ['budget'],
    readScope: 'project_working_set',
    queuedWriteRisk: 'high',
    conflictPolicy: 'server_authoritative',
    supportsSelectiveFileCache: false,
    requiredForLaunch: true,
  },
  {
    routeId: 'osi',
    path: '/osi',
    entities: ['owner_supplied_item'],
    readScope: 'project_working_set',
    queuedWriteRisk: 'medium',
    conflictPolicy: 'field_level_merge',
    supportsSelectiveFileCache: true,
    requiredForLaunch: true,
  },
  {
    routeId: 'warranty',
    path: '/warranty',
    entities: ['warranty'],
    readScope: 'project_working_set',
    queuedWriteRisk: 'medium',
    conflictPolicy: 'human_review_required',
    supportsSelectiveFileCache: true,
    requiredForLaunch: true,
  },
  {
    routeId: 'quality',
    path: '/quality',
    entities: ['quality_item', 'file_asset'],
    readScope: 'project_working_set',
    queuedWriteRisk: 'medium',
    conflictPolicy: 'append_only',
    supportsSelectiveFileCache: true,
    requiredForLaunch: true,
  },
  {
    routeId: 'visits',
    path: '/visits',
    entities: ['site_visit', 'capture', 'file_asset'],
    readScope: 'selective_file_cache',
    queuedWriteRisk: 'medium',
    conflictPolicy: 'append_only',
    supportsSelectiveFileCache: true,
    requiredForLaunch: true,
  },
  {
    routeId: 'brief',
    path: '/brief',
    entities: ['site_visit_brief'],
    readScope: 'project_working_set',
    queuedWriteRisk: 'low',
    conflictPolicy: 'field_level_merge',
    supportsSelectiveFileCache: true,
    requiredForLaunch: true,
  },
  {
    routeId: 'reports',
    path: '/reports',
    entities: ['report', 'dossier_snapshot'],
    readScope: 'project_working_set',
    queuedWriteRisk: 'low',
    conflictPolicy: 'append_only',
    supportsSelectiveFileCache: true,
    requiredForLaunch: true,
  },
  {
    routeId: 'handover',
    path: '/handover',
    entities: ['handover', 'handover_run', 'file_asset'],
    readScope: 'selective_file_cache',
    queuedWriteRisk: 'high',
    conflictPolicy: 'human_review_required',
    supportsSelectiveFileCache: true,
    requiredForLaunch: true,
  },
  {
    routeId: 'foundation',
    path: '/foundation',
    entities: ['stakeholder', 'contract', 'position', 'file_asset'],
    readScope: 'selective_file_cache',
    queuedWriteRisk: 'high',
    conflictPolicy: 'human_review_required',
    supportsSelectiveFileCache: true,
    requiredForLaunch: true,
  },
  {
    routeId: 'records',
    path: '/records',
    entities: ['meeting_minutes', 'correspondence'],
    readScope: 'project_working_set',
    queuedWriteRisk: 'low',
    conflictPolicy: 'append_only',
    supportsSelectiveFileCache: true,
    requiredForLaunch: true,
  },
] as const satisfies readonly NavioBuildOfflineCapability[];
